
const bookServiceForm = document.getElementById('bookService')
const store = document.querySelector('.product-form__store-availability-container')

if (window.location.pathname === '/products/upsale') {
  document.body.innerHTML = ''; 
  window.location.href = '/'; 
}

document.addEventListener('DOMContentLoaded', () => {
  const paymentTermsElement = document.querySelector('shopify-payment-terms');
  
  if (paymentTermsElement) {
    paymentTermsElement.style.opacity = 0;
  }
});

// if(window.location.pathname === '/products/oxo') {
//   store.remove();
// }


function getWeekdays() {
  const today = new Date();
  const startOfWeek = today.getDate() - today.getDay() + (today.getDay() === 0 ? -6 : 1); // Start from Monday
  let weekdays = [];

  for (let i = 0; i < 5; i++) { // Loop for Monday to Friday
    const date = new Date(today.getFullYear(), today.getMonth(), startOfWeek + i);
    if (date > today) { // Ensure the day is today or later
      weekdays.push({
        shortDay: date.toLocaleDateString('en-US', { weekday: 'short' }), // e.g., Mon
        shortMonth: date.toLocaleDateString('en-US', { month: 'short' }), // e.g., Mar
        day: date.getDate() // e.g., 8
      });
    }
  }

  return weekdays;
}

// Function to generate time slots
function generateTimeSlots() {
  const slots = [];
  const startTime = 9; // Start at 9:00
  const endTime = 18; // End at 18:00

  for (let hour = startTime; hour < endTime; hour += 2) {
    const slot = `${hour}:00 - ${hour + 2}:00`;
    slots.push(slot);
  }

  return slots;
}

  function checkSelections() {
    if (daySelected && timeSlotSelected) {
      btn.disabled = false;
    }
  }

// Handle Day Selection and Display Time Slots
  function handleDaySelection(event) {
    // Remove active class from all days
    const allDays = document.querySelectorAll('.day-square');
    allDays.forEach((day) => {
      day.classList.remove('active');
    });

    // Add active class to the selected day
    const selectedDay = event.currentTarget;
    selectedDay.classList.add('active');
    daySelected = true; // Mark day as selected

    // Populate and display time slots only after day selection
    const timeSlots = generateTimeSlots();
    populateTimeSlotsRow(timeSlots);

    // Display time slots row
    const timeSlotsRow = document.getElementById('timeSlotsRow');
    timeSlotsRow.style.display = 'flex';

    // Check if both selections are made
    checkSelections();
  }



// Populate the days row
function populateDaysRow(weekdays) {
  const daysRow = document.getElementById('daysRow');
  
  weekdays.forEach((day) => {
    const daySquare = document.createElement('div');
    daySquare.classList.add('day-square');
    
    // Use template literals to insert HTML content
    daySquare.innerHTML = `
      <div class="day-short">${day.shortDay}</div>
      <div class="month-short">${day.shortMonth}</div>
      <div class="day-num">${day.day}</div>
    `;

    // Add event listener for the click event
    daySquare.addEventListener('click', handleDaySelection);

    // Append the daySquare to the daysRow
    daysRow.appendChild(daySquare);
  });
}


function isProductPage() {
    // Checks if the current URL contains '/products/'
    return window.location.pathname.includes('/products/');
}


let prd_tabs = {

    init: function (){

        this._events();
    },

    _events: function (){

        let self = this,
            body = document.querySelector('body');

        body.addEventListener('click', function (e) {

            let target = e.target;

            if(target.classList.contains('prd-tab-btn')) {

                e.preventDefault();

                let parent = target.closest('.tabs-section'),
                    id = target.dataset.id,
                    tab = document.querySelector('#tab_'+id);

                if(typeof tab !== 'undefined' && tab != null) {

                    for(let item of parent.querySelectorAll('.prd-tab-btn')) {
                        item.classList.remove('active');
                    }

                    for(let item of parent.querySelectorAll('.tab')) {
                        item.classList.remove('show');
                    }

                    target.classList.add('active');
                    tab.classList.add('show');
                }



            }

        })


    }

}

// prd_tabs.init();


let global = {

    init: function () {

        this._events();
    },

    prd_info_payments_change: function (){

        let prd_info_price_list = document.querySelector('.prd-info-price-list');
      // console.log(prd_info_price_list)

        // let price = prd_info_price_list.dataset.price,
        //     discount = prd_info_price_list.dataset.discount,
            let price = prd_info_price_list.dataset.discount,
            discount = prd_info_price_list.dataset.price,
            month = prd_info_price_list.querySelector('.month'),
            all = prd_info_price_list.querySelector('.all');


        let picked_price = discount;

        if(picked_price <= 0) {
            picked_price = price;
        }

        picked_price = parseFloat(picked_price);

        let USDollar = new Intl.NumberFormat('en-US', {
            style: 'currency',
            currency: 'USD',
        });

        let m_price = USDollar.format(picked_price / 12);


        month.querySelector('.price span').innerHTML = m_price;

        if(price > 0) {
          
            all.querySelector('.subtitle strike').innerHTML = USDollar.format(price);
            all.querySelector('.subtitle').classList.remove('hide');

            all.querySelector('.info span').innerHTML = USDollar.format(parseFloat(price) - parseFloat(discount));
            all.querySelector('.info').classList.remove('hide');


        }else {
            all.querySelector('.subtitle').classList.add('hide');
            all.querySelector('.info').classList.add('hide');
        }

        all.querySelector('.price').innerHTML = USDollar.format(picked_price);


    },

  

    _events: function () {


        let self = this,
            body = document.querySelector('body');


        body.addEventListener('click', function (e) {


            let target = e.target;

            if(target.classList.contains('color_click')) {

                e.preventDefault();

                let color = target.closest('.color'),
                    background = color.dataset.img,
                    parent = color.closest('.section-colors');

                for(let item of parent.querySelectorAll('.colors .color')) {
                  
                    item.classList.remove('active');
                }

                color.classList.add('active');

                  console.log(background);

                let val = "url('"+background+"')";

           

                parent.querySelector('.bg').style.setProperty('--background',val);

                return;
            }


        });

        body.addEventListener('change', function (e) {


            let target = e.target;


            if(target.classList.contains('block-swatch__radio')) {

                let price = target.dataset.price,
                 discount = target.dataset.discount;

                let prd_info_price_list = document.querySelector('.prd-info-price-list');

                prd_info_price_list.dataset.price = price;
                prd_info_price_list.dataset.discount = discount;

                self.prd_info_payments_change();

                return;
            }

        })

    }
}

// global.init();





let paymentModule = (function () {
    function _toggleActivePaymentClass(clickedItem) {
        const items = document.querySelectorAll('.prd-info-price-list .item');
        items.forEach(function (item) {
            item.classList.remove('active_payment');
        });
        clickedItem.classList.add('active_payment');
    }

    function _setupEventListeners() {
        const prdInfoPriceList = document.querySelector('.prd-info-price-list');

        if (prdInfoPriceList) {
            prdInfoPriceList.addEventListener('click', function(event) {
                const clickedItem = event.target.closest('.item');
                if (clickedItem) {
                    _toggleActivePaymentClass(clickedItem);
                }
            });
        } else {
            console.error("Parent element with class 'prd-info-price-list' not found.");
        }
    }


    return {
        init: function() {
            window.addEventListener('load', _setupEventListeners);
        }
    };
})();

// paymentModule.init(); 



let modalModule = {
    init: function() {
        // Selecting the elements
        const modalTrigger = document.getElementById('modal_choose_model');
        const backdrop = document.querySelector('.wd-backdrop');
        const modal = document.querySelector('.wd-modal');
        const closeModalElements = document.querySelectorAll('.wd-backdrop, .close');
        const modalContent = modal.querySelector('.wd-modal-content');
        let modalContentHtml = "";
        if (modalTrigger) {
          modalContentHtml = modalTrigger.dataset.modalContent || "";
        }

        // Function to open the modal
        function openModal() {
            backdrop.classList.add('is-open');
            modal.classList.add('is-open');
            modalContent.innerHTML = modalContentHtml
        }

  

        // Event listener for opening the modal
        if (modalTrigger) {
            modalTrigger.addEventListener('click', openModal);
        }

    
    }
};


let colorSwatchesModule = {
    init: function() {
        // Initialize color to image map
        let colorToImageMap = {};

        // Function to setup color swatches
        function setupColorSwatches() {
            const colorSwatchesInput = document.getElementById('colorSwatchesData');
            if (colorSwatchesInput && colorSwatchesInput.value) {
                const colorSwatchesJSON = colorSwatchesInput.value;
                const colorSwatchesObj = JSON.parse(colorSwatchesJSON);

                if (colorSwatchesObj && colorSwatchesObj.colors) {
                    colorSwatchesObj.colors.forEach(function(colorObj) {
                        colorToImageMap[colorObj.color.toLowerCase()] = colorObj.image;
                    });
                } else {
                    console.log("The 'colors' property does not exist in the parsed object.");
                }
            } else {
                console.log("Color swatches input element is missing or empty.");
            }
        }

        // Function to handle swatch click
 function onSwatchClick(event) {
  const color = event.currentTarget.dataset.color.toLowerCase();
  const colorName = document.getElementById('color-name');

  if (!colorName) return;

  if (window.location.pathname === '/products/oxo') {
    if (color === "white") {
      colorName.innerHTML = `Special Edition ${color}`;
    } else {
      colorName.innerHTML = `Carbon Skin ${color}`;
    }
  } else {
    colorName.innerHTML = color;
  }
   

    if (colorToImageMap[color]) {
        const mobileSwatchImg = document.getElementById('mobile-swatch');
        if (mobileSwatchImg) {
            mobileSwatchImg.src = colorToImageMap[color];
        } else {
            console.log("Mobile swatch image element not found.");
        }
    } else {
        console.log("Image URL not found for color:", color);
    }
}

        // Setting up event listeners for color swatches
        function setupEventListeners() {
            const colorSwatches = document.querySelectorAll('.color-swatch__item');
            colorSwatches.forEach(function(swatch) {
                swatch.addEventListener('click', onSwatchClick);
            });
        }

        // Initialize module
        setupColorSwatches();
        setupEventListeners();
    }
};






if (isProductPage()) {
    prd_tabs.init();
    global.init();
    paymentModule.init();
    modalModule.init();
  colorSwatchesModule.init();
}



if (bookServiceForm) {
  const addToCart = document.getElementById('AddToCart');
  const btn = bookServiceForm.querySelector('.btn');
  btn.disabled = true; // Initially disable the button
  // const availability = document.querySelector('.store-availability-container');
  // addToCart.style.display = "none";
  // availability.style.display = "none";

  let daySelected = false;
  let timeSlotSelected = false;

  const weekdays = getWeekdays();

  // Populate the days row
  populateDaysRow(weekdays);

  // Enable the button if both day and time slot are selected
  function checkSelections() {
    if (daySelected && timeSlotSelected) {
      btn.disabled = false;
    }
  }

  // Handle Day Selection and Display Time Slots
  function handleDaySelection(event) {
    // Remove active class from all days
    const allDays = document.querySelectorAll('.day-square');
    allDays.forEach((day) => {
      day.classList.remove('active');
    });

    // Add active class to the selected day
    const selectedDay = event.currentTarget;
    selectedDay.classList.add('active');
    daySelected = true; // Mark day as selected

    // Populate and display time slots only after day selection
    const timeSlots = generateTimeSlots();
    populateTimeSlotsRow(timeSlots);

    // Display time slots row
    const timeSlotsRow = document.getElementById('timeSlotsRow');
    timeSlotsRow.style.display = 'flex';

    // Check if both selections are made
    checkSelections();
  }

  // Handle Time Slot Selection
  function handleTimeSlotSelection(event) {
    // Remove active class from all time slots
    const allTimeSlots = document.querySelectorAll('.time-button');
    allTimeSlots.forEach((slot) => {
      slot.classList.remove('active');
    });

    // Add active class to the selected time slot
    const selectedTimeSlot = event.currentTarget;
    selectedTimeSlot.classList.add('active');
    timeSlotSelected = true; // Mark time slot as selected

    // Check if both selections are made
    checkSelections();
  }

  // Populate the time slots row
  function populateTimeSlotsRow(timeSlots) {
    const timeSlotsRow = document.getElementById('timeSlotsRow');
    timeSlotsRow.innerHTML = ''; // Clear any existing slots

    timeSlots.forEach((slot) => {
      const timeButton = document.createElement('button');
      timeButton.classList.add('time-button');

      // Use template literals to set the button's inner content
      timeButton.innerHTML = `${slot}`;

      // Add event listener for the click event
      timeButton.addEventListener('click', (e) => {
        e.preventDefault();
        handleTimeSlotSelection(e);
      });

      // Append the timeButton to the timeSlotsRow
      timeSlotsRow.appendChild(timeButton);
    });
  }

  bookServiceForm.addEventListener('submit', async (e) => {
    e.preventDefault();
    addToCart.style.display = "block";
    bookServiceForm.remove();
  });
}






document.addEventListener('DOMContentLoaded', () => {
  const checkbox = document.getElementById('upsell-switch');
  const label = document.getElementById('care-label');

  // const checkboxUpsale = document.getElementById('bundle-switch');

  //   checkboxUpsale.addEventListener('change', () => {
  //   // const upsaleVariantId = checkboxUpsale.value; 
  //     console.log(upsaleVariantId)
  //   if (checkboxUpsale.checked) {
  //     addToCart(upsaleVariantId, 1);
  //   } else {
  //     removeFromCart(upsaleVariantId);
  //   }
  // });

  console.log(checkbox)

  checkbox.addEventListener('change', () => {
    console.log("change")
    const careVariantId = checkbox.value; // Get the variant ID from the checkbox value
    if (checkbox.checked) {
      addToCart(careVariantId, 1);
      // label.textContent = 'Added Inokim care!';
    } else {
      removeFromCart(careVariantId);
      // Optional: handle other actions if needed
    }
  });

  const addToCart = async (variantId, quantity) => {
    try {
      const response = await fetch('/cart/add.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          items: [{
            id: variantId,
            quantity: quantity
          }]
        })
      });
      const data = await response.json();
      console.log('Product added to cart:', data);
      // Optionally, update the cart UI here
    } catch (error) {
      console.error('Error adding product to cart:', error);
    }
  };

  const removeFromCart = async (variantId) => {
    try {
      const response = await fetch('/cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json'
        },
        body: JSON.stringify({
          updates: {
            [variantId]: 0
          }
        })
      });
      const data = await response.json();
      console.log('Product removed from cart:', data);
      // Optionally, update the cart UI here
    } catch (error) {
      console.error('Error removing product from cart:', error);
    }
  };
});



    function startCountdown() {
      const countdownElm = document.querySelector(".countdownElm");
      const targetTime = parseInt(countdownElm.getAttribute("data-countdown")) * 1000;
      
      function updateCountdown() {
        const currentTime = new Date().getTime();
        const timeLeft = targetTime - currentTime;

        if (timeLeft <= 0) {
          countdownElm.querySelector(".days").textContent = 0;
          countdownElm.querySelector(".hours").textContent = 0;
          countdownElm.querySelector(".minutes").textContent = 0;
          countdownElm.querySelector(".seconds").textContent = 0;
          return;
        }

        const days = Math.floor(timeLeft / (1000 * 60 * 60 * 24));
        const hours = Math.floor((timeLeft % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((timeLeft % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((timeLeft % (1000 * 60)) / 1000);

        countdownElm.querySelector(".days").textContent = days;
        countdownElm.querySelector(".hours").textContent = hours;
        countdownElm.querySelector(".minutes").textContent = minutes;
        countdownElm.querySelector(".seconds").textContent = seconds;
      }

      updateCountdown();
      setInterval(updateCountdown, 1000);
    }

    startCountdown();





